/**
 * Reads a `PUBLIC_`/`VITE_`-prefixed var from `window.env`, injected at
 * container boot (`fenv.sh`) or dev-server start (`rsbuild.config.ts`),
 * sourced from `.env` locally or `cloudformation.yml` when deployed.
 */
export function readPublicEnv(key: string): string | undefined {
  // Node-side tests import modules that read config at load time; there is no
  // window there, and "not set" is the right answer.
  return typeof window === 'undefined' ? undefined : window.env?.[key];
}

declare global {
  interface Window {
    env?: Record<string, string>;
  }
}
